export const BASE_URL_BACK =
	process.env.NODE_ENV === 'production'
		? process.env.API_SERVER
		: process.env.API_SERVER_DEV;
